import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import { HTTP_TIMEOUT } from '../../interceptor/timeout.interceptor';

// const CLLIST = makeStateKey('countryLangList');

@Injectable({
  providedIn: 'root'
})
export class CountryLanguageService {
  countryLanguageList: any = [];
  welcomeMessage: any;
  regionlist: any;
  private countryLanguageData: any;
  private _contentObservable: Observable<any>;

  constructor(
    private http: HttpClient,
    private applicationConfig: ApplicationConfig,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  countryLanguageDataFromAPI() {
    if (this.countryLanguageData) {
      return of(this.countryLanguageData);
    } else if (this._contentObservable) {
      return this._contentObservable;
    } else if (isPlatformBrowser(this.platformId)) {
      const svcTimeOut: number = Number.parseInt(
        this.applicationConfig.get('APP_TIMEOUT_FAST')
      );
      const retries: number = Number.parseInt(
        this.applicationConfig.get('APP_RETRIES')
      );
      let headers = new HttpHeaders();
      headers = headers.set(HTTP_TIMEOUT, svcTimeOut.toString());
      headers = headers.set('Content-Type', 'application/json; charset=UTF-8');
      const requestOptions = { headers: headers, params: new HttpParams() };
      this._contentObservable = this.http
        .get(
          `${this.applicationConfig.get('APP_COUNTRY_LANGUAGE_URL')}`,
          requestOptions
        )
        .pipe(
          map((data) => {
            this._contentObservable = null;
            this.countryLanguageData = data;
            // this.cache.set(CLLIST, data);
            return this.countryLanguageData;
          }),
          share()
        );
    }

    return this._contentObservable;
  }
}
